import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { submitAdditionalPqlForm } from 'ui-addon-upgrades/_core/pql/submitPql';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UITextArea from 'UIComponents/input/UITextArea';
import { track } from '../common/eventTracking/tracker';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { StyledModal } from '../common/components/StyledModal';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PQL_SUBMISSION_STATUSES = {
  INITIAL: 'initial',
  LOADING: 'loading',
  FAILED: 'failed',
  SUCCEEDED: 'succeeded'
};
const MODAL_CLOSE_DELAY_MILLIS = 800;
const EmailModal = ({
  onClose,
  hideBackground,
  upgradeData,
  isUpgradePoint,
  repInfo
}) => {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [hasClickedSubmit, setHasClickedSubmit] = useState(false);
  const [pqlSubmissionStatus, setPqlSubmissionStatus] = useState(PQL_SUBMISSION_STATUSES.INITIAL);
  const handleSubmit = () => {
    setHasClickedSubmit(true);
    if (subject.length && body.length) {
      setPqlSubmissionStatus(PQL_SUBMISSION_STATUSES.LOADING);
      submitAdditionalPqlForm(Object.assign({}, upgradeData, {
        isAssignable: true,
        isRetail: false,
        repInfo
      }), {
        emailSubject: subject,
        emailBody: body
      }).then(() => {
        setPqlSubmissionStatus(PQL_SUBMISSION_STATUSES.SUCCEEDED);
        track('communicationMethodsInteraction', Object.assign({
          action: 'submitted email message',
          repName: getRepName(repInfo)
        }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint)));
        setTimeout(() => {
          onClose();
        }, MODAL_CLOSE_DELAY_MILLIS);
      }).catch(() => {
        //Do we want to set an alert in this case?
        setPqlSubmissionStatus(PQL_SUBMISSION_STATUSES.FAILED);
      });
    }
  };
  return /*#__PURE__*/_jsxs(StyledModal, {
    "data-test-id": "email-modal",
    width: 600,
    hideBackground: hideBackground,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.emailModal.header"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => onClose()
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.emailModal.subject"
        }),
        error: hasClickedSubmit && !subject.length,
        validationMessage: hasClickedSubmit && !subject.length && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.emailModal.errorMessages.subject"
        }),
        children: /*#__PURE__*/_jsx(UISelect, {
          value: subject,
          "data-test-id": "pql-email-subject-dropdown",
          searchable: false,
          onChange: ({
            target: {
              value
            }
          }) => setSubject(value)
          //The message subjects are submitted to 53 in English
          ,
          options: [{
            text: I18n.text(`upgrades.emailModal.subjectDropdown.options.purchase`),
            value: 'I’m interested in purchasing a product'
          }, {
            text: I18n.text(`upgrades.emailModal.subjectDropdown.options.learnMore`),
            value: 'I want to learn more about a product or feature'
          }, {
            text: I18n.text(`upgrades.emailModal.subjectDropdown.options.help`),
            value: 'I need setup help or have a technical question'
          }, {
            text: I18n.text(`upgrades.emailModal.subjectDropdown.options.other`),
            value: 'Other'
          }],
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.emailModal.subjectDropdown.placeholder"
          })
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.emailModal.body"
        }),
        error: hasClickedSubmit && body === '',
        validationMessage: hasClickedSubmit && body === '' && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.emailModal.errorMessages.body"
        }),
        children: /*#__PURE__*/_jsx(UITextArea, {
          "data-test-id": "pql-email-message-textarea",
          placeholder: I18n.text('upgrades.emailModal.bodyPlaceholder'),
          rows: 10,
          resize: false,
          value: body,
          onChange: ({
            target: {
              value
            }
          }) => setBody(value)
        })
      }), pqlSubmissionStatus === PQL_SUBMISSION_STATUSES.FAILED && /*#__PURE__*/_jsx(UIAlert, {
        className: "m-top-5",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.emailModal.submissionErrors.title"
        }),
        type: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.emailModal.submissionErrors.body"
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UILoadingButton, {
        use: "primary",
        "data-test-id": "pql-email-submit",
        onClick: handleSubmit,
        loading: pqlSubmissionStatus === PQL_SUBMISSION_STATUSES.LOADING,
        keepResultAfterFinish: pqlSubmissionStatus !== PQL_SUBMISSION_STATUSES.FAILED,
        failed: pqlSubmissionStatus === PQL_SUBMISSION_STATUSES.FAILED,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.emailModal.send"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: () => onClose(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.emailModal.cancel"
        })
      })]
    })]
  });
};
export default EmailModal;